import { Layout, Row, Col } from "antd";
import { HeartFilled } from "@ant-design/icons";

function Footer() {
  const { Footer: AntFooter } = Layout;
  const currentYear = new Date().getFullYear();

  return (
    <AntFooter style={{ background: "#fafafa" }}>
      <Row align="middle">
        <Col xs={24} md={12}>
          <div className="copyright">
            © {currentYear} • Built with{" "}
            <span className="font-weight-bold">SenseInsights</span>
          </div>
        </Col>

        <Col xs={24} md={12}>
          <div className="footer-menu">
            <ul>
              <li className="nav-item">
                <a
                  href="/"
                  className="nav-link text-muted"
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/about"
                  className="nav-link text-muted"
                >
                  About
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/privacy-policy"
                  className="nav-link text-muted"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/terms"
                  className="nav-link pe-0 text-muted"
                >
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </AntFooter>
  );
}

export default Footer;
